import React, { useState } from 'react';

import './Programs.patient.enroll.scss';

import Modal from 'react-modal';
import Input from '../forms/inputs/Input';
import { useQuery, useMutation } from '@apollo/client';
import gqlSchemaLibrary from '../services/graphql.schemas';
import {PatientAvatar} from '../visuals/Patient.avatar';
import Button from '../forms/buttons/Button';
import ButtonProgress from '../forms/buttons/Button.progress';
import {getDOB} from "../utils/date";
import {useTranslation} from "react-i18next";
import DropdownMultiSelectCliniciansTeams from "../forms/dropdown/dropdown.multiselectec.clinicians";
import {ModalLog} from "../services/interactions/elements/modal";
import AuditTrail, {PAGES} from "../services/interactions/audit.trail";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: "none",
        padding: "0px",
        boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.38)",
    }
};
Modal.setAppElement('#root');

const _Modal = ModalLog(Modal);

function ProgramsBaseEnrollPatientDialog({ currentOrg, openModal, program, closeModal }) {
    const {t} = useTranslation(['programs','common','devices','participants'])
    const [search, setSearch] = useState('');
    const [patients, setPatients] = useState({ getUserPatients: [] });
    const [selectable, setSelectable] = useState({});
    const [enrolling, setEnrolling] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);

    useQuery(gqlSchemaLibrary.patients.getPersonByOrganization, {
        onCompleted: (onPatients) => {
            console.log('[Patient Enroll] User Patients: ', onPatients);
            if (onPatients.getPersonByOrganization) {
                setPatients({ getUserPatients: onPatients.getPersonByOrganization.filter(p => !p.programId) })
            }
        },
        fetchPolicy: 'cache-and-network'
    });

    const [enrollPatients] = useMutation(gqlSchemaLibrary.patients.mutations.enrollPatient, {
        onCompleted: ({enrollPatient}) => {
            console.log('[Patient Enroll] response: ', enrollPatient);
            setEnrolling(false);
            closeModalSuccess()
        }
    })

    const enrollSelection = () => {
        setEnrolling(true);
        const patientIds = Object.keys(selectable).reduce((p,c) => {
            if(selectable[c]){
                p.push(c);
            }
            return p;
        },[]);
        const users = selectedItems.filter((i) => i.type === 'User').map((u) => u.value);
        const teams = selectedItems.filter((i) => i.type === 'Team').map((u) => u.value);
        enrollPatients({
            variables:{
                enrollments: {
                    patientIds,
                    programId: program._id,
                    users: users,
                    teams: teams
                }
            }
        });
    }

    const selectPatient = (patient) => {
        return () => {
            AuditTrail.sendLog(PAGES.PROGRAM_PARTICIPANTS, {tag: 'row', event: 'onClick', action: 'selected patient row', program_id: program._id, patient_id: patient._id, selected: !selectable[patient._id]});
            selectable[patient._id] = !selectable[patient._id];
            setSelectable(Object.assign({}, selectable));
        }
    }

    const closeModalEmpty = () => {
        closeModal(false);
    }

    const closeModalSuccess = () => {
        closeModal(true);
    }

    const onChange = (items) => {
        setSelectedItems(items);
    }

    const patientsFiltered = !!search ? patients.getUserPatients.filter(up => {
        const _search = search.toLowerCase();
        return up.user.bio.lastname.toLowerCase().includes(_search) || up.user.bio.firstname.toLowerCase().includes(_search)
    }) : patients.getUserPatients;

    return (
        <_Modal
            isOpen={!!openModal}
            onRequestClose={closeModalEmpty}
            style={customStyles}
            contentLabel={t('participant-kit-assignment')}
            label="ProgramsBaseEnrollPatientDialog"
            event={PAGES.PROGRAM_PARTICIPANTS}
            eventParams={{program_id: program._id}}>
            <div id="ProgramsBaseEnrollPatientDialog">
                <div className="__EnrollPatientTitle">
                    <h3>Enroll Participant</h3>
                    <p className="title">{program.name}</p>
                    <div className="_clinicians">
                        <label>
                            {t('assign-clinician-opt')}
                        </label>
                        <DropdownMultiSelectCliniciansTeams program={program._id} displayLabel={"Choose the options"} items={selectedItems} onChange={onChange} event={PAGES.PROGRAM_PARTICIPANTS} />
                    </div>
                    <div className="_nameSearch">
                        <Input onChange={setSearch} label={t('select-participant-enrollment')} value={search} placeholder={t('search-participant-enroll')} event={PAGES.PROGRAM_PARTICIPANTS} />
                    </div>
                </div>
                <div className="__EnrollCandidates">
                    <div className="_patOption header">
                        <div className="_optBio">
                            <p>Results {search ? `${t('devices:for')} ${search}` : ''}</p>
                            <p></p>
                            <p className="end">{patientsFiltered.length} {patientsFiltered.length === 1? t('participant') : t('participants')}</p>
                        </div>
                    </div>
                    {patientsFiltered.map((patient) => (
                        <div key={patient._id} className={`_patOption ${selectable[patient._id] ? 'selected' : ''}`}>
                            <div className="_optBio">
                                <PatientAvatar bio={patient.user.bio} small={true}/>
                                <div className="_name">
                                    <p>{patient.user.bio.lastname}, {patient.user.bio.firstname}</p>
                                    <div className="_nameBio">
                                        {getDOB(currentOrg, patient.dateOfBirth, patient.user.bio.gender, 'small')}
                                    </div>
                                </div>
                                <div className={`_toSelect ${selectable[patient._id] ? 'selected' : ''}`} onClick={selectPatient(patient)}>
                                        {
                                            !selectable[patient._id] ? 
                                            <i className="material-icons">add</i> :
                                            <i className="material-icons">check</i> 
                                        }
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="actions">
                    <Button className="tertiary" handleClick={closeModalEmpty}>
                        {t('common:cancel')}
                    </Button>
                    <ButtonProgress inProgress={enrolling} handleClick={enrollSelection} className="primary" disabled={!Object.keys(selectable).reduce((p,c) => p || selectable[c], false)}>
                        {t('participants:enroll')}
                    </ButtonProgress>
                </div>
            </div>
        </_Modal>
    )
}

export default ProgramsBaseEnrollPatientDialog;
